import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { trackAppFallartSelect } from '@/lib/tracking';
import {
  TrendingUp,
  ShoppingCart,
  ArrowLeftRight,
  Scroll,
  CloudRain,
  TreePine,
  ShieldAlert,
  HelpCircle,
  ArrowRight,
} from 'lucide-react';

const FALLARTEN = [
  { id: 'waldwert', icon: TrendingUp, labelKey: 'landing.fallartenWaldwert', descKey: 'landing.fallartenWaldwertDesc' },
  { id: 'kaufen', icon: ShoppingCart, labelKey: 'landing.fallartenKaufen', descKey: 'landing.fallartenKaufenDesc' },
  { id: 'verkaufen', icon: ArrowLeftRight, labelKey: 'landing.fallartenVerkaufen', descKey: 'landing.fallartenVerkaufenDesc' },
  { id: 'geerbt', icon: Scroll, labelKey: 'landing.fallartenGeerbt', descKey: 'landing.fallartenGeerbtDesc' },
  { id: 'schaden', icon: CloudRain, labelKey: 'landing.fallartenSchaden', descKey: 'landing.fallartenSchadenDesc' },
  { id: 'pflege', icon: TreePine, labelKey: 'landing.fallartenPflege', descKey: 'landing.fallartenPflegeDesc' },
  { id: 'wild', icon: ShieldAlert, labelKey: 'landing.fallartenWild', descKey: 'landing.fallartenWildDesc' },
  { id: 'unsicher', icon: HelpCircle, labelKey: 'landing.fallartenUnsicher', descKey: 'landing.fallartenUnsicherDesc' },
];

export default function FallartenAuswahl() {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-warm-50 border-y border-warm-200" data-testid="fallarten-auswahl">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            {t('landing.fallartenTitle')}
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            {t('landing.fallartenSubtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="fallarten-grid">
          {FALLARTEN.map((fa) => {
            const Icon = fa.icon;
            return (
              <Link
                key={fa.id}
                to={`/schnell-check?fallart=${fa.id}`}
                onClick={() => trackAppFallartSelect(fa.id)}
                className="group rounded-xl border border-warm-200 bg-white px-4 py-5 flex flex-col transition-all hover:border-primary/30 hover:shadow-sm"
                data-testid={`fallart-${fa.id}`}
              >
                <div className="w-9 h-9 rounded-lg bg-primary/8 flex items-center justify-center mb-3">
                  <Icon className="h-5 w-5 text-primary" />
                </div>
                <h3 className="text-sm font-semibold text-gray-900 mb-1.5 leading-tight">
                  {t(fa.labelKey)}
                </h3>
                <p className="text-xs text-gray-500 leading-relaxed flex-1">
                  {t(fa.descKey)}
                </p>
                <div className="flex items-center gap-1 text-xs text-primary font-medium mt-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  {t('landing.heroCta')}
                  <ArrowRight className="h-3 w-3" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
